<div class="image-panel">
</div>
<div class="metadata-panel">
  <div class="editor-fields-container"></div>
</div>
